module.exports = __webpack_public_path__ + "img/6owl door.7c1778c4.svg";